module.exports = __webpack_public_path__ + "img/japan-transport-accidents-female.7e39a6be.png";